import script from "./AvatarWithFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarWithFrame.vue?vue&type=script&setup=true&lang=js"

import "./AvatarWithFrame.vue?vue&type=style&index=0&id=4161542e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4161542e"]])

export default __exports__